import React , {useState} from 'react'

export default function TextForm(props) {
    const handleUpClick= ()=>{
        // console.log("Uppercase was clicked" + text);
        let newText=text.toUpperCase();
        setText(newText)
        props.showAlert("Converted to upper case","success")
    }
    const handleLoClick= ()=>{
      // console.log("Uppercase was clicked" + text);
      let newText=text.toLowerCase();
      setText(newText)
      props.showAlert("Converted to lower case","success")
  }
  const handleToClear= ()=>{
    // console.log("Uppercase was clicked" + text);
    let newText=" ";
    setText(newText)
    props.showAlert("Clear Text","success")
  }
  const handleCopy= ()=>{
    var text=document.getElementById("myBox");
    text.select();
    navigator.clipboard.writeText(text.value);
    props.showAlert("Copied to clipboard","success")
  }
  const handleExtraSpaces = ()=>{
    let newText=text.split(/[ ]+/);
    setText(newText.join(" "))
    props.showAlert("Removed extra spaces","success")
  }
    const handleOnChange= (event)=>{
        // console.log("on change");
        setText(event.target.value);
    }
    const[text,setText]=useState('Enter text 2 here');
    // setText=("new text");
  return (
    <>
   
    <div className='container'style={{color: props.mode ==='dark'?'white':'#042743' }}>
        <h1>{props.heading}</h1>
<div className="mb-3">
  <textarea className="form-control" value={text} onChange={handleOnChange} style={{backgroundColor: props.mode ==='dark'?'grey':'white',color: props.mode ==='dark'?'white':'#042743'  }} id="myBox" rows="10"></textarea>
</div>
<button className="btn btn-primary mx-2 my-1" onClick={handleUpClick}>Convert to Uppercase</button>
<button className="btn btn-primary mx-2 my-1"  onClick={handleLoClick}>Convert to Lowercase</button>
<button className="btn btn-primary mx-2 my-1"  onClick={handleToClear}>Clear text</button>
<button className="btn btn-primary mx-2 my-1"  onClick={handleCopy}>Copy Text</button>
<button className="btn btn-primary mx-2 my-1"  onClick={handleExtraSpaces}>Remove Extra Spaces</button>
    </div>
    <div className="container" style={{color: props.mode ==='dark'?'white':'#042743' }} my-2>
      <h1>Your text Summary</h1>
      <p>{text.split(" ").filter((element)=>{return element.length!==0}).length} words and {text.length} characters</p>
      <p>{0.008*text.split(" ").length}Minutes read</p>
      <h2>Preview</h2>
       <p>{text}</p>
    </div>
    </>
  )
}
